import { ISelectionBoxProps } from "../../properties/BoxProperties";

const SelectionBox = ({
  optionList,
  selectedId,
  handleSelectOnClick,
}: ISelectionBoxProps) => {
  return (
    <div className="sbx-row">
      {optionList.map((option: any, index: number) => (
        <div
          key={index}
          className={`${
            option.id === selectedId ? "sbx-item-selected" : "sbx-item-unselected"
          } sbx-item sbx-px-8`}
          onClick={() => {
            handleSelectOnClick(option.id);
          }}
        >
          <div
            className={`sbx-content ${
              option.id === selectedId ? "" : "sbx-dim"
            }`}
          >
            {option.icon}
            <div className="sbx-text">
              <p>{option.text}</p>
              {option.subText ? (
                <p className="sbx-subtext">({option.subText})</p>
              ) : null}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SelectionBox;
